<template>
  <div>
    <div>
      <!-----------------heading and buttons ---------------------->
      <v-row class="d-flex justify-space-between" flat>
        <v-col cols="12" class="d-flex align-center">
          <v-btn icon to="/DigitalManual" color="transparent" class="mr-2">
            <v-icon color="black"> mdi-keyboard-backspace</v-icon>
          </v-btn>
          <h1 class="heading-1">Manual Versions</h1>
        </v-col>
      </v-row>
      <!----------------- search and filter ---------------------->
      <div class="my-3">
        <v-row class="mt-6">
          <v-col cols="12" xl="4">
            <v-card flat>
              <v-text-field
                dense
                outlined
                prepend-inner-icon="mdi-magnify"
                label="Search"
                v-model="search"
                hide-details
                single-line
              >
              </v-text-field>
            </v-card>
          </v-col>
        </v-row>
      </div>
      <!----------------- data table ---------------------->
      <v-card class="mt-6" outlined>
        <v-data-table
          :headers="headers"
          :loading="tableLoader"
          loading-text="Loading... Please wait"
          :items="GetManualVersion"
          :search="search"
          :page.sync="page"
          :single-expand="singleExpand"
          :expanded.sync="expanded"
          item-key="Id"
          show-expand
          :items-per-page="itemsPerPage"
          @page-count="pageCount = $event"
          hide-default-footer
        >
          <template v-slot:[`item.index`]="{ item }">
            <b> {{ item.Id }} </b>
          </template>
    
          <template v-slot:[`item.Title`]="{ item }">
            <span class="table_style_one">
              <b> {{ item.Title }} </b></span
            >
          </template>
          <template v-slot:[`item.numberOfVersion`]="{ item }">
            <span class="table_style_two">
              {{ item.VersionCount }}
            </span>
          </template>
          <template v-slot:[`item.numberOfLanguage`]="{ item }">
            <span class="table_style_two">
              <!-- {{ item.DigitalManualFiles.length }} -->
              {{ new Set(item.DigitalManualFiles.map(file => file.Language)).size }}
            </span>
          </template>
          <template v-slot:[`item.CreatedDate`]="{ item }">
            <span class="table_style_two">{{
              checkDate(item.CreatedDate)
            }}</span>
          </template>
          
          <!-----------------Expanded data table ---------------------->
          <template v-slot:expanded-item="{ headers, item }">
            <td :colspan="headers.length">
              <div style="display: none">More info about {{ item.id }}</div>
              <v-card class="my-6" outlined v-show="item.Id">
                <v-data-table
                  :headers="headers2"
                  :loading="tableLoader"
                  loading-text="Loading... Please wait"
                  :items="item.DigitalManualFiles"
                  :search="search"
                  :page.sync="page"
                  item-key="Id"
                  :items-per-page="itemsPerPage"
                  @page-count="pageCount = $event"
                  hide-default-footer
                >
                  <template v-slot:[`item.index`]="{ item }">
                    <b> {{ item.Version }} </b>
                  </template>

                  <template v-slot:[`item.title`]="{ item }">
                    <span class="table_style_one">
                      {{ item.File.split("_")[1] }}
                    </span>
                  </template>
                  <template v-slot:[`item.language`]="{ item }">
                    <span class="table_style_two">
                      {{ item.Language }}
                    </span>
                  </template>
                  <template v-slot:[`item.numberOfVersion`]="{ item }">
                    <span class="table_style_two">
                      {{ item.DigitalManualFiles && 
                         item.VersionCount 
                      }}
                      
                    </span>
                  </template>
                  <template v-slot:[`item.numberOfLanguage`]="{ item }">
                    <span class="table_style_two">
                    {{
                      item.DigitalManualFiles && 
                      item.DigitalManualFiles.length
                    }}
                    </span>
                  </template>
                  <template v-slot:[`item.lastUpdate`]="{ item }">
                    <span class="table_style_two">
                      {{ checkDate(item.CreatedDate) }}
                    </span>
                  </template>

                  <template v-slot:[`item.File`]="{ item }">
                    <v-list class="px-3 pt-1" color="transparent">
                      <v-btn
                        depressed
                        color="transparent"
                        class="d-flex justify-start"
                        @click="openLink(item.File)"
                      >
                        <v-icon color="#646464">mdi-tray-arrow-down</v-icon>
                      </v-btn>
                    </v-list>
                  </template>
                </v-data-table>
              </v-card>
            </td>
          </template>
        </v-data-table>
      </v-card>
      <v-card flat class="my-9 d-flex justify-end align-center">
        <span class="text_transform pa-0 ma-0">Per page : </span>
        <v-card flat width="100" class="mx-5">
          <v-select
            :items="ItemsPerPageItems"
            label="Items per page"
            v-model="itemsPerPage"
            @change="fetchData()"
          ></v-select>
        </v-card>
        <v-pagination
          v-model="page"
          :length="pageCount"
          :total-visible="5"
          @input="fetchData"
        ></v-pagination
      ></v-card>
    </div>
    <!------------Update manual dialog-------------------------->
    <v-dialog v-model="UploadManualDialog" persistent max-width="600">
      <v-card>
        <div class="mx-8 py-5 d-flex justify-space-between">
          <span class="heading-2"> <b> Upload Manual</b></span>
          <v-icon @click="UploadManualDialog = false">mdi-close</v-icon>
        </div>
        <UploadManualComponent
          :UploadManual="UploadManualDialog"
          @close="close"
        ></UploadManualComponent>
      </v-card>
    </v-dialog>
    <!------------Edit manual dialog-------------------------->
    <v-dialog v-model="EditManualDialog" persistent max-width="600">
      <v-card>
        <div class="mx-8 py-5 d-flex justify-space-between">
          <span class="heading-2"> <b> Edit Manual</b></span>
          <v-icon @click="EditManualDialog = false">mdi-close</v-icon>
        </div>
        <EditManualComponent
          :EditManual="EditManualDialog"
          @close="close"
        ></EditManualComponent>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import UploadManualComponent from "../../components/DigitalManual/UploadManual.component.vue";
import EditManualComponent from "../../components/DigitalManual/EditManual.component.vue";
import { mapGetters } from "vuex";
import moment from "moment";
export default {
  components: { UploadManualComponent, EditManualComponent },
  data() {
    return {
      LanguageArray: [
        "English",
        "French",
        "German",
        "Japanese",
        "Italian",
        "Portuguese",
        "Filipino",
        "Spanish",
        "Chinese",
        "Russian",
      ],
      expanded: [],
      singleExpand: false,
      UploadManualDialog: false,
      EditManualDialog: false,
      filterDialog: false,
      ItemsPerPageItems: [10, 50, 100, 200, "All"],
      page: 1,
      pageCount: 1,
      itemsPerPage: 10,
      valid: false,
      dialog: false,
      isPlaying: false,
      editvideodialog: false,
      newcategorydialog: false,
      organizedialog: false,
      SeeProfileDialog: false,
      tableLoader: false, // data-table true or false
      add_dialog: false,
      btnloader: false,
      test: true,
      NameCategory: "",
      Language: "",
      search: "",

      headers: [
        { text: "Title", value: "Title" },
        {
          text: "Number of Languages",
          value: "numberOfLanguage",
          sortable: false,
        },
        {
          text: "Number of Versions",
          value: "numberOfVersion",
          sortable: false,
        },
        { text: "Last Updated", value: "ModifiedDate" },
        { text: "", value: "actions", sortable: false },
      ],
      headers2: [
        { text: "Version #", value: "index" },
        { text: "File Name", value: "title" },
        { text: "Language", value: "Language" },
        { text: "Upload Date", value: "lastUpdate" },
        { text: "", value: "File", sortable: false },
      ],
      DataTableOne: [],
      DataTableTwo: [],
      Fitems: [],
      Fitems2: [],
    };
  },
  computed: {
    ...mapGetters(["GetManualVersion"]),
  },
  mounted() {
    this.tableLoader = true;
    this.fetchData();
    this.tableLoader = false;
  },
  methods: {
    openLink(url) {
      const googleDriveUrl = process.env.VUE_APP_IMG_URL + url;
      window.open(googleDriveUrl, "_blank");
    },
    GoToArchived(item) {
      this.$store.dispatch("AddArchivedDigitalManula", item).then(()=>{
        this.fetchData();
         this.$swal.fire({
          toast: true,
          position: "top-end",
          icon: "success",
          title: "Unarchive successfully",
          showConfirmButton: false,
          timer: 1500,
        });
      });
    },
    GetArchive() {
      this.$store.dispatch("GetDigitalArchiveManuals");
    },
    fetchData(){
      this.tableLoader = true;
      var obj = {
        page: this.page,
        pageSize: this.itemsPerPage,
        search: this.search,
      };
      this.$store.dispatch("GetManualVersion", obj).then((res) => {
        this.tableLoader = false;
        if (this.itemsPerPage != "All") {
          this.pageCount = Math.ceil(res.TotalRecords / this.itemsPerPage);
        } else {
          this.pageCount = 1;
          this.page = 1;
        }
      });
    },
    close() {
      this.UploadManualDialog = false;
      this.EditManualDialog = false;
    },
    checkDate(x) {
      return moment(x).format("MM/DD/YY");
    },
    send() {
      setTimeout(() => {
        this.btnloader = true;
      }, 100);
      setTimeout(() => {
        this.organizedialog = false;
        this.btnloader = false;
        this.newcategorydialog = false;
        this.editvideodialog = false;
      }, 2000);
    },
  },
};
</script>
<style scoped>
.v-text-field--outlined >>> fieldset {
  border-color: #e0e0e0;
}

.text_trans {
  text-transform: none;
}
</style>
